// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__28dBN","notes":"Notes_notes__1U8-7"};